import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";

import { REDUCTION_ROUTE_SEGMENTS } from "../../shared/routing/paths/reduction";
import { commonLabels } from "../../shared/ui/labels/common-labels";
import {
  ReductionBaselinePage,
  ReductionLandingPage,
  ReductionMeasuresPage,
  ReductionRoadmapPage,
  ReductionRoute,
  ReductionScenariosPage,
  ReductionWizardLayout,
} from "./route-elements";
import { reductionRouteLabels } from "./shared/labels/route-labels";

// Breadcrumb labels sit on the routes (`handle.crumb`, see `shared/layout/breadcrumbs.tsx`). The
// pathless parent carries the hub's "Home" crumb, which resolves to `/`.
export const ReductionRoutes = {
  handle: { crumb: commonLabels.navigation.home },
  children: [
    {
      path: REDUCTION_ROUTE_SEGMENTS.root,
      handle: { crumb: reductionRouteLabels.landing },
      element: <ReductionRoute />,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Spinner />}>
              <ReductionLandingPage />
            </Suspense>
          ),
        },
        {
          path: REDUCTION_ROUTE_SEGMENTS.planId,
          handle: { crumb: reductionRouteLabels.wizard },
          element: (
            <Suspense fallback={<Spinner />}>
              <ReductionWizardLayout />
            </Suspense>
          ),
          children: [
            {
              path: REDUCTION_ROUTE_SEGMENTS.baseline,
              element: (
                <Suspense fallback={<Spinner />}>
                  <ReductionBaselinePage />
                </Suspense>
              ),
            },
            {
              path: REDUCTION_ROUTE_SEGMENTS.measures,
              element: (
                <Suspense fallback={<Spinner />}>
                  <ReductionMeasuresPage />
                </Suspense>
              ),
            },
            {
              path: REDUCTION_ROUTE_SEGMENTS.scenarios,
              element: (
                <Suspense fallback={<Spinner />}>
                  <ReductionScenariosPage />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: `${REDUCTION_ROUTE_SEGMENTS.planId}/${REDUCTION_ROUTE_SEGMENTS.roadmap}`,
          handle: { crumb: reductionRouteLabels.roadmap },
          element: (
            <Suspense fallback={<Spinner />}>
              <ReductionRoadmapPage />
            </Suspense>
          ),
        },
      ],
    },
  ],
};
